import * as React from 'react';
import { ReactNode } from 'react';
import { SuggestApi, UsersDTO } from '../../../api/admin';
import { ValidationResult } from '../../../util/validation/interfaces';
import { Suggester } from '../../edit/components/suggester/Suggester';
import { ApiResponse, SolrDocument } from '../../../api/core';

interface Props {
  value: UsersDTO[];
  onChange: (values: UsersDTO[]) => void;
  multiple: boolean;
  disabled?: boolean;
  required?: boolean;
  validation?: ValidationResult;
  inputId?: string;
  autoFocus?: boolean;
  border?: 'border-noround' | 'border-noround-right';
}

export function UserSuggester(props: Props): ReactNode {
  const request = (params: { q: string }): Promise<ApiResponse<SolrDocument[]>> =>
    new SuggestApi().usersSuggestRaw(params);

  const selectedItemTemplate = (item: UsersDTO): ReactNode => {
    return <></>;
  };

  const itemTemplate = (item: UsersDTO): ReactNode => {
    return (
      <div className={'flex flex-column gap-1 p-1'}>
        <div>{`${item.givenname} ${item.surname}`}</div>
        <div className={'text-sm'}>{item.username}</div>
      </div>
    );
  };

  return (
    <Suggester<UsersDTO, UsersDTO>
      itemTemplate={itemTemplate}
      autoFocus={props.autoFocus}
      selectedItemTemplate={selectedItemTemplate}
      load={request}
      map={(usr: SolrDocument): UsersDTO => ({id: usr.id, givenname: usr.givenname, surname: usr.surname, username: usr.username })}
      inputId={props.inputId}
      value={props.value}
      disabled={props.disabled}
      validation={props.validation}
      required={props.required}
      onChange={props.onChange}
      border={props.border}
      multiple={props.multiple}/>
  );
}
